import React, {Component, useState} from 'react';
import {Link,} from 'react-router-dom';
import {connect} from "react-redux";
import {Button} from "finform";

import {
    handleCloseModal,
    handleForgotModal,
    handleLoginModal,
    handleRegisterModal,
    logout
} from "#app/redux/actions/auth";
import {Modal, ModalClose, ModalContent, ModalFooter, ModalHeader} from "#app/interface/modal/Modal";
import Forgot from "#app/pages/Auth/Forgot";
import Register from "#app/pages/Auth/Register";
import FormOnLogin from "#app/pages/Auth/Components/FormOnLogin";

import {Title2} from "#app/components/Text/Typography";

import {
    HeaderContainer,
    HeaderLogo,
    HeaderMenu,
    HeaderOther,
    HeaderOtherComment,
    HeaderOtherLink,
    HeaderPersonal,
    HeaderWrapper,
    ModalText,
    Wrap,
} from './styles';
import {Row} from "#app/pages/styles";

class Header extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isScrolled: false,
            showFooter: true
        };

        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        document.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        document.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll(e) {
        if (window.pageYOffset > 0) {
            this.setState({
                isScrolled: true
            });
        } else if (window.pageYOffset === 0) {
            this.setState({
                isScrolled: false
            });
        }
    }

    renderLoginModal() {
        return (
            <Modal
                size='extra-small'
                onClose={() => {
                    Modal.handleClose();
                    this.props.handleCloseModal();
                }}
                show={this.props.showLoginModal}
                trigger={''}
            >
                <ModalHeader>
                    <Title2 white>Вход</Title2>
                    <ModalClose onClick={() => {
                        Modal.handleClose();
                        this.props.handleCloseModal();
                    }}>
                        <div/>
                    </ModalClose>
                </ModalHeader>
                <ModalContent>
                    <FormOnLogin/>
                </ModalContent>
                <ModalFooter>
                </ModalFooter>
            </Modal>
        );
    }

    renderRegisterModal() {
        return <Modal
            size='extra-small'
            onClose={() => {
                Modal.handleClose();
                this.props.handleCloseModal();
            }}
            show={this.props.showRegisterModal}
            trigger={''}
        >
            <ModalHeader>
                <Title2 white>Регистрация</Title2>
                <ModalClose onClick={() => {
                    Modal.handleClose();
                    this.props.handleCloseModal();
                }}>
                    <div/>
                </ModalClose>
            </ModalHeader>
            <ModalContent>
                <Register/>
            </ModalContent>
            {this.state.showFooter && <ModalFooter>
                <Row>
                    <ModalText>У вас есть аккаунт?</ModalText>
                </Row>
                <Button wide id='login-modal-button' onClick={(e) => {
                    e.preventDefault();

                    this.props.handleLoginModal();
                }}>Войти</Button>
            </ModalFooter>}
        </Modal>;
    }

    renderForgotModal() {
        return <Modal
            size='extra-small'
            onClose={() => {
                Modal.handleClose();

                this.props.handleCloseModal();
            }}
            show={this.props.showForgotModal}
            trigger={''}
        >
            <ModalHeader>
                <Title2 white>Забыли пароль</Title2>
                <ModalClose onClick={() => {
                    Modal.handleClose();

                    this.props.handleCloseModal();
                }}>
                    <div/>
                </ModalClose>
            </ModalHeader>
            <ModalContent>
                <Forgot callback={() => {
                    Modal.handleShow();

                    this.props.handleLoginModal();
                }}/>
            </ModalContent>
            {this.state.showFooter && <ModalFooter>
                <Button wide onClick={() => {
                    Modal.handleClose();

                    this.props.handleCloseModal();
                }}>Отмена</Button>
            </ModalFooter>}
        </Modal>;
    }

    render() {
        const ModalWrapper = (props) => {
            const [open, setOpen] = useState(false);

            return <HeaderWrapper>
                <HeaderContainer className={this.state.isScrolled ? 'scrolled' : ''}>
                    <Wrap>
                        <HeaderLogo><Link to="/">white swan</Link></HeaderLogo>
                        <HeaderMenu style={this.state.isScrolled ? {
                            transform: 'translate3d(0,-50%,0)',
                            opacity: 1
                        } : {}}>
                        </HeaderMenu>
                    </Wrap>
                    <HeaderPersonal>
                        <Link to='/cabinet' id='login-button' className='style2' onClick={(e) => {
                            if (this.props.auth) {
                                return;
                            }
                            e.preventDefault();
                            Modal.handleShow();
                            this.props.handleLoginModal();
                        }}>
                            Войти
                        </Link>
                        {/* <a id={'login-button'} className='style2' onClick={(e) =>
          {
            e.preventDefault();

            if(this.props.auth)
            {
              history.push('/cabinet')
            }else{
              Modal.handleShow();
              this.props.handleLoginModal();
            }
          }}>Войти</a> */}
                    </HeaderPersonal>
                    <HeaderOther>
                        <a href="https://whiteswan.finance">
                            <HeaderOtherLink/>
                            <HeaderOtherComment style={this.state.isScrolled ? {display: 'none'} : {}}>
                                Приложение для финансового учёта
                            </HeaderOtherComment>
                        </a>
                    </HeaderOther>
                </HeaderContainer>
                {this.renderLoginModal()}
                {this.renderRegisterModal()}
                {this.renderForgotModal()}
            </HeaderWrapper>

        }


        return <ModalWrapper/>
    }
}

const enhance = connect(
    (state) => ({
        auth: state.auth.auth,
        data: state.auth.data,
        showLoginModal: state.auth.showLoginModal,
        showRegisterModal: state.auth.showRegisterModal,
        showForgotModal: state.auth.showForgotModal,
    }),
    {logout, handleLoginModal, handleCloseModal, handleRegisterModal, handleForgotModal}
)
export default enhance(Header);
// export default withRouter(enhance(Header));
